<!-- @format -->
<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading fudisDialogTitle [level]="2">
      {{ t("ENROLMENT_QUESTIONS.TITLE") }}
    </fudis-heading>
    <fudis-heading [level]="3">
      {{ courseUnitName | localizedString }}{{ courseUnitName || courseUnitRealisationName ? ", " : ""
      }}{{ courseUnitRealisationName | localizedString }}
    </fudis-heading>
    <fudis-dialog-content>
      @if (hasQuestions) {
        <fudis-dl>
          @for (qa of questionAnswers; track qa.id) {
            <fudis-dl-item>
              <fudis-dt [contentText]="qa.question | localizedString"></fudis-dt>
              @if (qa.isLanguageSelection && qa.answer) {
                <fudis-dd [contentText]="qa.answer | codeLocalizedName | async"></fudis-dd>
              } @else {
                <fudis-dd [contentText]="qa.answer ? qa.answer : t('ENROLMENT_QUESTIONS.NO_ANSWER')"></fudis-dd>
              }
            </fudis-dl-item>
          }
        </fudis-dl>
      } @else {
        <fudis-body-text class="storybook__item">{{ t("ENROLMENT_QUESTIONS.NO_QUESTIONS") }}</fudis-body-text>
      }
    </fudis-dialog-content>
  </fudis-dialog>
</ng-container>
